const angular = require('angular');

const PartnerService = require('./partner.service');
const partnerDirectiveDefinition = require('./partner.directive');
const partnerSmallFormatDirectiveDefinition = require('./partner-smallformat.directive');
const { conveniencePackTileListComponentDefinition } = require('./convenience-pack-tile-list.component');

angular.module('wowApp.shop')
    .service('PartnerService', ['Restangular', PartnerService])
    .directive('wowPartner', ['AddressService', 'PartnerService', '$state', partnerDirectiveDefinition])
    .directive('wowPartnerSmallFormat', [partnerSmallFormatDirectiveDefinition])
    .component('wowConveniencePackTileList', conveniencePackTileListComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/partner/index.js